import request from '@/utils/request'

export function getSettingsSunday(data) {
  return request({
    url: '/api/work/settings/sunday',
    method: 'post',
    data,
  })
}
